import { useDispatch } from "react-redux";
import { DeviceType } from "src/globalTypes/device";
import { useIsMobile } from "src/hooks/viewport/useViewportCategory";
import { GoogleSignInParams } from "src/utils/googleSignInPopup";
import { eraseLoginError } from "../actionCreators/authentication/loginCreator";
import * as TH from "../thunks";

export const useLoginUserAction = () => {
  const dispatch = useDispatch();
  return (loginName?: string, password?: string, forceCheck?: boolean) =>
    dispatch(TH.login(loginName, password, forceCheck));
};

export const useGoogleLoginAction = () => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const deviceType = isMobile ? DeviceType.Mobile : DeviceType.Web;
  return ({ token }: GoogleSignInParams) =>
    dispatch(TH.googleLogin(token, deviceType));
};

export const useMicrosoftLoginAction = () => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const deviceType = isMobile ? DeviceType.Mobile : DeviceType.Web;
  return (token: string) => dispatch(TH.microsoftLogin(token, deviceType));
};

export const useActiveDirectoryLoginAction = () => {
  const dispatch = useDispatch();
  return (login: string, password: string) =>
    dispatch(TH.activeDirectoryLogin(login, password));
};

export const useLogoutUserAction = () => {
  const dispatch = useDispatch();
  return () => dispatch(TH.logout());
};

export const useEraseLoginError = () => {
  const dispatch = useDispatch();
  return () => dispatch(eraseLoginError());
};
